import { ref, watch } from 'vue';
import { login, logout } from '@/api';
import type { Token } from '@/types';
import { useNotifications } from '@/composables/useNotifications';
import { useThrottleFn } from '@vueuse/core';

const tenantUuid = ref<string>('');
const userId = ref<string>('');
const sevenToken = ref<Token>(null);
const integrationToken = ref<Token>(null);

let isWatcherInitialized = false;

export const useAuthToken = () => {
  const { setNotification } = useNotifications();

  const waitMagicGamesLoaded = async () => {
    if (window.MagicGames?.Loaded === 1) return;

    await new Promise<void>((resolve) => {
      const interval = setInterval(() => {
        if (window.MagicGames?.Loaded === 1) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  };

  const handleTokenChange = useThrottleFn(async (newSevenToken: Token, oldSevenToken: Token) => {
    if (newSevenToken) {
      const { token, error, message } = await login(newSevenToken, userId.value, tenantUuid.value);

      if (error) {
        setNotification(message);
        integrationToken.value = null;
      } else {
        integrationToken.value = token;
      }
    } else if (oldSevenToken && !newSevenToken) {
      const { error, message } = await logout(oldSevenToken, userId.value, tenantUuid.value);

      if (error) {
        setNotification(message);
      } else {
        integrationToken.value = null;
        userId.value = '';
      }
    }
    await waitMagicGamesLoaded();
    window.MagicGames.SetUserToken({ UserToken: integrationToken.value ?? '' });
  }, 1000);

  if (!isWatcherInitialized) {
    isWatcherInitialized = true;
    watch(sevenToken, handleTokenChange);
  }

  return {
    sevenToken,
    integrationToken,
    userId,
    tenantUuid
  };
};
